export const diffInDays = (startDate: Date, endDate: Date) =>
  Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
